import { apiService } from "../_services";

export default {
  namespaced: true,
  state: {
    panel: false,
    entries: {
      count: 0,
      groups: {}
    }
  },
  getters: {
    entries(state) {
      return state.entries;
    },
    newEntries(state) {
      if (state.entries.groups.hasOwnProperty("new")) {
        return state.entries.groups.new.groupPosts;
      } else {
        return [];
      }
    },
    panelStatus(state) {
      return !!state.panel;
    }
  },
  actions: {
    getNotifications({ commit }) {
      apiService.notifications.all().then(response => {
        commit("updateEntries", response.data);
      });
    },
    setNotifications({ commit }, entries) {
      commit("updateEntries", entries);
    },
    openPanel({ commit }) {
      commit("openPanel");
    },
    closePanel({ commit }) {
      commit("closePanel");
    },
    togglePanel({ commit }) {
      commit("togglePanel");
    }
  },
  mutations: {
    updateEntries(state, payload) {
      state.entries = payload;
    },
    openPanel(state) {
      state.panel = true;
    },
    closePanel(state) {
      state.panel = false;
    },
    togglePanel(state) {
      state.panel = !state.panel;
    }
  }
};
